import { useSelector } from 'react-redux';
import { getNasServices } from '../model';
import { useBackToOrder } from './useBackToOrder';
import { getOrder } from '../../../../Checkout/store/order/selectors';
export const useRefundNasServices = ({ onSuccess }) => {
    const order = useSelector(getOrder);
    const { onBackToOrder } = useBackToOrder(true);
    const nasServices = useSelector(getNasServices);
    return {
        services: (nasServices === null || nasServices === void 0 ? void 0 : nasServices.services) || [],
        selectedServices: (nasServices === null || nasServices === void 0 ? void 0 : nasServices.selectedServices) || [],
        onSuccessfullyRefunded: onSuccess,
        onCancel: onBackToOrder,
        order,
        travellersToRefund: order.travellers.map(traveller => traveller.id),
        isRefundOrExchange: true
    };
};
